module.exports = __webpack_public_path__ + "img/龙卷风.0220b00d.png";